import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { recursosBecas } from 'src/app/recursos/interfaz';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';
import { LoaderComponent } from 'src/app/servicios/loader/loader.component';

@Component({
  selector: 'app-estudio-socio-economico2025',
  templateUrl: './estudio-socio-economico2025.component.html',
  styleUrls: ['./estudio-socio-economico2025.component.css']
})
export class EstudioSocioEconomico2025Component implements OnInit {

  public mr: NgbModalRef;
  public vecPeriodo = []; vecParametro = []; vecEcVariable = []; vecEcDetalle = []; vecQuintil = []; public valTotal = 0;
  public vecCertificados: Array<any>; private urlFrima: string;
  public vecResEconomico = []; public vecAjustes = [];
  public encabezado: string = ""; public nombreBeca: string = ""; public vecInfoEst = []; public vecEstudiante = [];
  opEditable: boolean = true; opVerObserva: boolean = true; public verObservacion: string = '';
  pdfSrc: SafeResourceUrl | undefined; rutaFirma: string = '';
  pdfDoc: any; private tokenDrive: string = '';

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvSelect: SeleccionService, private srvInsert: IngresoService,
    private sanitizer: DomSanitizer, private recBecas: recursosBecas, private srvGeneral: recursosCompartido, private cargando: LoaderComponent) { }

  async ngOnInit() {
    this.encabezado = "Estudio Socio económico";
    this.nombreBeca = localStorage.getItem('modNom');
    this.instanciaBuscarEstudiante();
    this.cargarPeriodos();
    this.instanciaDataEstudiante('', '', '', '', '', '', '', '', '', '', '', '', '', '', 0, 1, '', 0, 0, 0, localStorage.getItem('modNom'), '', '');
    this.tokenDrive = await this.srvGeneral.getTokenLocal();
  }
  //INTANCIAMOS EL VECTOR DE LA INFORMACION DE LA MATRIZ DE BEP
  instanciaDataEstudiante(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, dato14, dato15, dato16, dato17, dato18,
    dato19, dato20, dato21, dato22, dato23) {
    this.vecEstudiante = [];
    let auxPeriodo = this.vecPeriodo.filter(objPer => objPer.codigo == dato9);
    this.vecEstudiante.push({
      cedula: dato1, nombres: dato2, apellidos: dato3, correo: dato4, nombFacultad: dato5, nombCarrera: dato6, codNivel: dato7, carrera: dato8, periodo: dato9,
      codigoEstudiante: dato10, promedio: dato11, tipoEst: dato12, celular: dato13, fecha: dato14, respuesta: dato15, quintil: dato16, detalle: dato17, beca: dato18,
      aprueba: dato19, estado: dato20, nombBeca: dato21, detPeriodo: auxPeriodo.length > 0 ? auxPeriodo[0]['descripcion'] : '', valQuintil: 0,
      analista: '', cargoAna: '', director: '', cargoDir: '', responsable: dato22, respCedula: dato23, tipoProm: ''
    });
  }
  //INTANCIAMOS EL VECTOR CON LOS PARAMETROS DE BUSQUEDA
  instanciaBuscarEstudiante() {
    this.vecParametro = []; this.vecEcVariable = []; this.vecEcDetalle = []
    this.vecParametro.push({ periodo: '', estudiante: '' });
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = []; this.vecEcVariable = []; this.vecEcDetalle = []; this.vecQuintil = [];
    //OBTENER LOS PERIODO ACADÉMICOS DE LA MASTER
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecParametro[0]['periodo'] = res.carrera[0]['strCodigo'];
      for (let i in res.carrera) {
        this.vecPeriodo.push({
          codigo: res.carrera[i]['strCodigo'], descripcion: res.carrera[i]['strDescripcion'], inicio: res.carrera[i]['dtFechaInic'], fin: res.carrera[i]['dtFechaFin']
        });
      }
    }
    //OBTENER LAS VARIABLES DEL ESTUDIO SOCIO ECONOMICO
    const resEconomico = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(1, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEconomico.resultado)
      this.vecEcVariable = resEconomico.socioEconomico;
    //VERIFICAMOS LAS RESPUESTAS MARCADAS EN CASO DE HABER HISTORIAL
    this.obtenerMarcaciones('na', 'na', 'na', 0);

    //OBTENER LAS VARIABLES DEL ESTUDIO SOCIO ECONOMICO
    const resQuintil = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(5, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resQuintil.resultado)
      this.vecQuintil = resQuintil.socioEconomico;

    this.vecAjustes = [];
    const resAjuste = await new Promise<any>(resolve => this.srvSelect.gestionBecas(14, localStorage.getItem('modBeca'), this.vecParametro[0]['periodo'], 'na')
      .subscribe(translated => { resolve(translated) }));
    if (res.success)
      this.vecAjustes = resAjuste.becas;
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE BUSCAR UN ESTUDIANTE
  bucarEstudiante(nameMod) {
    this.vecInfoEst = []; this.vecResEconomico = [];
    if (localStorage.getItem('modUser') == 'true')
      this.mr = this.modalService.open(nameMod);
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //CRITERIO DE VARIAS OPCIONES DE BUESQUEDA DE UN ESTUDIANTE
  async criterioBuscarEstudiante() {
    this.instanciaDataEstudiante('', '', '', '', '', '', '', '', '', '', '', '', '', '', 0, 1, '', 0, 0, 0, localStorage.getItem('modNom'), '', '');
    this.vecInfoEst = []; this.vecResEconomico = [];
    //BUSCAR LAS CONICIDENCIAS DE ESTUDIANTES SEGÚN EL CRITERIO DE BUSQUEDA
    const resEstudiantes = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(9, this.vecParametro[0]['estudiante'], 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEstudiantes.success)
      this.vecInfoEst = resEstudiantes.carrera;
    else
      this.alerti.error('No se encontró ningún estudiante');
  }

  //FUNCION QUE DETERMINA SI YA EXISTE UN ESTUDIO SOCIOECONOMICO O SE DEBE REALIZAR UN NUEVO
  async criterioDataEstudiante(objEst) {
    this.valTotal = 0;
    if (this.vecParametro[0]['periodo'] == this.vecPeriodo[0]['codigo']) {//SELECCIONA EL PERIODO ACTUAL, POR LO TANTO PUEDE CREAR O EDITAR EL ESTUDIO
      this.buscarEstudioRealizado(objEst.strCedula, this.vecParametro[0]['periodo'], 1, objEst);
    }
    else {//SELECCIONA UN PERIODO DIFERENTE POR LO TANTO DEBE CONSULTAR HISTORIALES
      this.opEditable = true;
      this.buscarEstudioRealizado(objEst.strCedula, this.vecParametro[0]['periodo'], 0, objEst);
    }
  }
  //BUSCAMOS Y CARGAMOS UN ESTUDIO YA REALIZADO
  async buscarEstudioRealizado(cedula, periodo, vigencia, dataEst) {
    await this.verDataEstudiante(dataEst, cedula);
    const resEstudio = await new Promise<any>(resolve => this.srvSelect.gestionSocioEconomico(6, cedula, periodo, localStorage.getItem('modBeca'), localStorage.getItem('ciUsuario'))
      .subscribe(translated => { resolve(translated) }));
    if (resEstudio.resultado) {
      this.cerrarModal();
      await this.instanciaDataEstudiante(resEstudio.socioEconomico[0].cedula, resEstudio.socioEconomico[0].nombres, resEstudio.socioEconomico[0].apellidos, '',
        resEstudio.socioEconomico[0].nomFacultad, resEstudio.socioEconomico[0].nomCarera, resEstudio.socioEconomico[0].nivel, resEstudio.socioEconomico[0].codCarrera,
        resEstudio.socioEconomico[0].periodo, resEstudio.socioEconomico[0].codigo, resEstudio.socioEconomico[0].promedio, '', '', resEstudio.socioEconomico[0].fecha.split('T')[0],
        resEstudio.socioEconomico[0].intIdRegistro, resEstudio.socioEconomico[0].quintil, resEstudio.socioEconomico[0].detalle, resEstudio.socioEconomico[0].beca,
        resEstudio.socioEconomico[0].aprobado, resEstudio.socioEconomico[0].estado, resEstudio.socioEconomico[0].nombBeca, resEstudio.socioEconomico[0].responsable, resEstudio.socioEconomico[0].registro);
      this.verPieFirmas(resEstudio.socioEconomico[0].registro);
      this.opEditable = localStorage.getItem('ciUsuario') == resEstudio.socioEconomico[0].registro ? false : true;

      //VERIFICAMOS LAS RESPUESTAS MARCADAS EN CASO DE HABER HISTORIAL
      this.obtenerMarcaciones(resEstudio.socioEconomico[0].codigo, resEstudio.socioEconomico[0].codCarrera, resEstudio.socioEconomico[0].periodo,
        resEstudio.socioEconomico[0].beca);
      if (vigencia == 1)
        this.verPromedioEstudiante(resEstudio.socioEconomico[0].codCarrera, resEstudio.socioEconomico[0].codigo, cedula);
    }
    else {
      if (vigencia == 0)
        this.alerti.error('No se encuentra registro para el período seleccionado.');
      else {
        this.instanciaDataEstudiante('', '', '', '', '', '', '', '', '', '', '', '', '', '', 0, 1, '', 0, 0, 0, localStorage.getItem('modNom'), '', '');
        await this.verDataEstudiante(dataEst, cedula);
        this.verPieFirmas(localStorage.getItem('ciUsuario'));
      }
    }
  }
  //FUNCION QUE MUESTRA LA INFORMACION DEL ESTUDIANTE SELECCIONADO
  async verDataEstudiante(objEstudiante, estudiante) {
    var buscar = objEstudiante.strCedula.replace('-', ''); var promedio = 0;
    let i = 0; let ban = 0; this.opEditable = true;
    if (buscar) {
      //OBTENER TODAS LAS INSCRIPCIONES DESDE LA MASTER
      const resMatrCarrera = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(1, 'na', buscar, 'na', 'na').subscribe(translated => { resolve(translated) }));
      if (resMatrCarrera.success) {
        while (i < resMatrCarrera.matricula.length && ban == 0) {
          const resMatricula = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(33, resMatrCarrera.matricula[i]['baseCarrera'],
            buscar, this.vecParametro[0]['periodo'], 'na').subscribe(translated => { resolve(translated) }));

          if (resMatricula.success) {
            if (resMatricula.matricula.filter(objMat => objMat.bytNumMat > 1).length == 0) {
              this.instanciaDataEstudiante(resMatricula.matricula[0]['strCedula'].replace('-', ''), resMatricula.matricula[0]['strNombres'], resMatricula.matricula[0]['strApellidos'],
                resMatricula.matricula[0]['strEmail'], resMatrCarrera.matricula[i]['nombFacultad'], resMatrCarrera.matricula[i]['nombCarrera'], resMatricula.matricula[0]['strCodNivel'],
                resMatrCarrera.matricula[i]['strCodCarrera'], resMatricula.matricula[0]['strCodPeriodo'], resMatricula.matricula[0]['strCodigo'], promedio.toFixed(2), 'MATRICULADO',
                resMatricula.matricula[0][''], resMatricula.matricula[0]['fechaActual'].split('T')[0], 0, 1, '', localStorage.getItem('modBeca'), 0, 1, localStorage.getItem('modNom'), '', '');
              ban = 1; this.opEditable = false;
              this.verPromedioEstudiante(resMatrCarrera.matricula[i]['strCodCarrera'], resMatricula.matricula[0].strCodEstud, estudiante);
            }
            else {
              this.opEditable = true;
              this.alerti.error('El estudiante presenta materias con segunda y/o tercera matrícula ');
            }
          }
          else {//SI EL ESTUDIANTE NO TIENE MATRÍCULA BUSCAMOS SI ES EGRESADO            
            const resEgreso = await new Promise<any>(resolve =>
              this.srvSelect.gestionMatricula(31, resMatrCarrera.matricula[i]['baseCarrera'], buscar, 'na', 'na').subscribe(translated => {
                resolve(translated)
              }));
            if (resEgreso.success) {
              ban = 1; this.opEditable = false;
              this.vecEstudiante[0]['tipoEst'] = 'Egresado';
              //SI EL ESTUDIANTE ESTÁ EGRESADO VERIFICAMOS SI ESTÁ TITULADO
              const resTitula = await new Promise<any>(resolve =>
                this.srvSelect.gestionMatricula(32, resMatrCarrera.matricula[i]['baseCarrera'], resEgreso.matricula[0]['intCodigo'], 'na', 'na').subscribe(translated => {
                  resolve(translated)
                }));
              if (resTitula.success) {
                this.alerti.error('El estudiante ya se encuentra titulado');
                ban = 0; this.opEditable = true;
                this.vecEstudiante[0]['tipoEst'] = 'Titulado';
              }
            }
          }
          i++;
        }
      }
      else
        this.alerti.error('No se encontró matrículas.');
      if (ban == 0)
        this.alerti.error('No se encontró matrículas.');
    }
    else
      this.alerti.error('Debe ingresar el número de cédula del estudiante.');
    this.cerrarModal();
  }
  //FUNCION QUE MUESTRA LA INFORMACION DEL ESTUDIANTE SELECCIONADO
  async verPromedioEstudiante(codCarrera, codEstudiante, cedEstudiante) {
    let sumaProm = 0; let contProm = 0;
    const resCarrera = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(4, codCarrera, 'na', 'na').subscribe(translated => { resolve(translated) }));
    if (resCarrera.success) {
      const resPromedioDos = await new Promise<any>(resolve => this.srvSelect.gestionMatriculaDosNotas(3, resCarrera.carrera[0]['baseCarrera'], codEstudiante, 'na', 'na')
        .subscribe(translated => { resolve(translated) }));
      if (resPromedioDos.success) {
        for (let objMat of resPromedioDos.matricula) {
          if (objMat.Equivalencia != 'R') {
            sumaProm += objMat.ComputoTotal; contProm++;
          }
        }
        if (contProm > 0) {
          this.vecEstudiante[0]['promedio'] = (sumaProm / contProm).toFixed(2);
          this.vecEstudiante[0]['tipoProm'] = '(Carrera)';
        }
      }
      if (contProm <= 0) {
        const resInscribe = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(1, 'na', cedEstudiante, 'na', 'na').subscribe(translated => { resolve(translated) }));
        if (resInscribe.success) {
          let vecNivelacion = resInscribe.matricula.filter(objIns => objIns.codFacultad == 'UNA')

          if (vecNivelacion.length > 0) {
            const resMatr = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(30, vecNivelacion[0].baseCarrera, cedEstudiante.replace('-', ''), 'na', 'na').subscribe(translated => { resolve(translated) }));
            if (resMatr.success) {
              const resPromNiv = await new Promise<any>(resolve => this.srvSelect.gestionMatriculaDosNotas(3, vecNivelacion[0].baseCarrera, resMatr.matricula[0].strCodigo,
                'na', 'na').subscribe(translated => { resolve(translated) }));
              if (resPromNiv.success) {
                let sumaProm = 0; let contProm = 0;
                for (let objMat of resPromNiv.matricula) {
                  if (objMat.Equivalencia != 'R') {
                    sumaProm += objMat.ComputoTotal; contProm++;
                  }
                }
                if (contProm > 0) {
                  this.vecEstudiante[0]['promedio'] = (sumaProm / contProm).toFixed(2);
                  this.vecEstudiante[0]['tipoProm'] = '(Nivelación)';
                }
              }
            }
          }
        }
      }
      await this.gestionRespuesta();

    }
  }
  //REGISTRO DE UNA RESPUESTA A LAS MARCACIONES
  gestionRespuesta() {
    //INGRESAMOS EL REGISTRO DEL ESTUDIO SOCIO ECONÓMICO
    this.srvInsert.ingresoSocioEconomico(this.vecEstudiante[0]['respuesta'], this.vecEstudiante[0]['cedula'], this.vecEstudiante[0]['codigoEstudiante'],
      this.vecEstudiante[0]['nombres'], this.vecEstudiante[0]['apellidos'], this.vecEstudiante[0]['nombFacultad'], this.vecEstudiante[0]['nombCarrera'],
      this.vecEstudiante[0]['carrera'], this.vecEstudiante[0]['codNivel'], this.vecEstudiante[0]['promedio'], this.vecEstudiante[0]['periodo'],
      this.vecEstudiante[0]['beca'], this.vecEstudiante[0]['detalle'], this.vecEstudiante[0]['quintil'], this.vecEstudiante[0]['aprueba'], localStorage.getItem('ciUsuario'),
      this.vecEstudiante[0]['estado'], 1).subscribe(res => {
        if (res.encuesta) {
          //VERIFICAMOS LAS RESPUESTAS MARCADAS EN CASO DE HABER HISTORIAL
          this.obtenerMarcaciones(this.vecEstudiante[0]['codigoEstudiante'], this.vecEstudiante[0]['carrera'], this.vecEstudiante[0]['periodo'], localStorage.getItem('modBeca'));
          this.alerti.success('Estudio registrado con éxito');
        }
      });
  }
  //VERIFICAMOS LAS RESPUESTAS MARCADAS EN CASO DE HABER HISTORIAL
  async obtenerMarcaciones(codigo, carrera, periodo, tipoBeca) {
    this.vecResEconomico = []; this.verObservacion = ''; this.valTotal = 0;
    ////////OBTENER LA RESPUESTA REGISTRADA PARA EL ESTUDIO
    const resResp = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(3, codigo, carrera, periodo, tipoBeca).subscribe(translated => {
        resolve(translated)
      }));
    this.vecEstudiante[0]['respuesta'] = resResp.resultado ? resResp.socioEconomico[0]['intIdRegistro'] : 0;
    ////////OBTENER EL DETALLE DEL ESTUDIO SOCIOECONOMICO CON LAS RESPUESTAS MARCADAS EN CASO DE HABER
    const resEcDetalle = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(2, resResp.resultado ? resResp.socioEconomico[0]['intIdRegistro'] : 0, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEcDetalle.resultado)
      this.vecEcDetalle = resEcDetalle.socioEconomico;
    ////////OBTENER LOS VALOR DE LAS MARCACIONES DEL ESTUDIO SOCIOECONOMICO
    const resValores = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(4, resResp.resultado ? resResp.socioEconomico[0]['intIdRegistro'] : 0, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resValores.resultado) {
      this.valTotal = 0;
      for (let objVal of resValores.socioEconomico) {
        this.vecResEconomico.push({ grupo: objVal.grupo, detalle: objVal.detalle, valor: objVal.valor, pos: this.vecResEconomico.length });
        this.valTotal += parseFloat(objVal.valor)
      }
      await this.calculoQuintil(this.valTotal);
    }
    ////////OBTENER LASOBSERVACIONES REGISTRADAS PARA EL ESTUDIO SOCIO ECONOMICO
    const resEcObserva = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(7, this.vecEstudiante[0].respuesta, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEcObserva.resultado) {
      if (resEcObserva.socioEconomico[0]['intEstado'] != 2) {
        this.pdfSrc = await this.srvGeneral.obtenerArchivoPDF(this.tokenDrive, resEcObserva.socioEconomico[0]['strRuta']);
      }
      this.opEditable = (resEcObserva.socioEconomico[0]['intEstado'] == 2) && (localStorage.getItem('ciUsuario') == this.vecEstudiante[0].respCedula) ? false : true;
      this.opVerObserva = (resEcObserva.socioEconomico[0]['intEstado'] == 2) && (localStorage.getItem('ciUsuario') == this.vecEstudiante[0].respCedula) ? false : true;
      this.verObservacion = resEcObserva.socioEconomico[0]['strDetalle'];
    }
  }
  //REGISTRAMOS LA MARCACION DE LAS OPCIONES DEL ESTUDIO SOCIOECONÓMICO
  verInformacion(dato) {
    let auxVecRes = []; this.valTotal = 0;

    auxVecRes = this.vecResEconomico.filter(objRes => objRes.grupo == dato.intIdEconomico);
    if (auxVecRes.length == 0)
      this.vecResEconomico.push({ grupo: dato.intIdEconomico, detalle: dato.intIdDetEconomico, valor: dato.cualificadores, pos: this.vecResEconomico.length });
    else {
      this.vecResEconomico[auxVecRes[0]['pos']]['detalle'] = dato.intIdDetEconomico;
      this.vecResEconomico[auxVecRes[0]['pos']]['valor'] = dato.cualificadores;
    }
    for (let objSum of this.vecResEconomico)
      this.valTotal += parseFloat(objSum.valor)
    this.srvInsert.ingresoSocioEconomico(dato.intIdEconomico, dato.intIdDetEconomico, dato.cualificadores, this.vecEstudiante[0]['respuesta'], 'na', 'na', 'na', 'na',
      'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', localStorage.getItem('ciUsuario'), 2).subscribe(res => {
        if (res.encuesta)
          this.calculoQuintil(this.valTotal);
        else
          this.alerti.error('Error inesperado vuelva a intentar más tarde');
      });
  }
  //DETERMINAR EL QUINTIL SEGUN LA PUNTUACION
  calculoQuintil(valor) {
    let auxQuintil = [];
    this.vecEstudiante[0]['valQuintil'] = valor;
    auxQuintil = this.vecQuintil.filter(objQui => valor.toFixed(2) >= objQui.valorInicio && objQui.valorFin == -1);
    if (auxQuintil.length == 0)
      auxQuintil = this.vecQuintil.filter(objQui => valor.toFixed(2) <= objQui.valorFin && objQui.valorInicio == -1);
    if (auxQuintil.length == 0)
      auxQuintil = this.vecQuintil.filter(objQui => objQui.valorInicio <= valor.toFixed(2) && objQui.valorFin >= valor.toFixed(2) && objQui.valorFin != -1 && objQui.valorInicio != -1);
    this.vecEstudiante[0]['quintil'] = auxQuintil[0]['quintil'];
    this.vecEstudiante[0]['aprueba'] = (this.vecEstudiante[0]['quintil'] <= 2) && (this.vecEstudiante[0]['promedio'] >= this.vecAjustes[0].fltPromedioMin ? 1 : 0);
  }
  //FUNCION QUE OBTIENE EL PDF
  async obtenerPdf() {
    this.cargando.abrir();
    const resEcDetalle = await new Promise<any>(resolve => this.srvSelect.gestionSocioEconomico(2, this.vecEstudiante[0]['respuesta'], 'na', 'na', 'na').subscribe(translated => {
      resolve(translated)
    }));
    if (resEcDetalle.resultado)
      this.vecEcDetalle = resEcDetalle.socioEconomico;

    const bitacora = await new Promise<any>(resolve =>
      this.srvInsert.generPDFBitacora(this.vecEstudiante, this.vecEcVariable, this.vecEcDetalle, this.vecQuintil).subscribe(translated => {
        resolve(translated)
      }));
    if (bitacora) {
      this.pdfDoc = bitacora.pdf;
      this.pdfSrc = await this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + bitacora.pdf);
      this.rutaFirma = btoa(bitacora.pdf);
    } else {
      this.alerti.error('No  se pudo Generar el pdf');
    }
    this.cargando.cerrar();
  }
  //HCER LA PETICION AL TRANSVERSAL DE FIRMAEC DESDE EL BOTON DEL MODAL
  async firmarArchivo() {
    let Firmax = 305; let Firmay = 183; let numPagina = 1
    this.vecCertificados = [];
    this.vecCertificados.push({ 'nombre': this.recBecas.nombreArchFirma, 'archivo': this.pdfDoc });
    var content = {
      'idAplicacion': this.recBecas.idAplicacion,
      'jwtsecret': this.recBecas.claveAplicacion,
      'activo': 'true',
      'cedula': localStorage.getItem('ciUsuario'),
      'listado': this.vecCertificados
    };
    const datos = await new Promise<any>((resolve) => this.srvInsert.FirmarEc(this.tokenDrive, content).subscribe((translated) => { resolve(translated); }));
    if (datos.success) {
      this.urlFrima = "firmaec://" + this.recBecas.apiKeyFirma + "/firmar?token=" + datos.data + "&tipo_certificado=2%26llx%3D" + Firmax + "%26lly%3D"
        + Firmay + "%26pagina%3D" + numPagina + "%26estampado%3DQR%26url%3Dhttp%3A%2F%2Fapifirmaec.espoch.edu.ec%2Fapi%26razon%3Dfirmado%20desde%20https%3A%2F%2Fsai.espoch.edu.ec";
      window.open(this.urlFrima, '_blank');
    }
  }
  async subirArchivo() {
    this.cargando.abrir();
    let archivoFile: any;
    const resFirma = await new Promise<any>((resolve) => this.srvInsert.obtener64Firmado(this.tokenDrive).subscribe((translated) => { resolve(translated); }));
    if (resFirma.success) {
      this.pdfSrc = await this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + resFirma.listado[0].archivoFirmado);
      archivoFile = await this.srvGeneral.dataURItoBlob(resFirma.listado[0].archivoFirmado, 'documentoFirmado.pdf');//OBTENGO EL FILE
      await this.subirPDFDrive(archivoFile);
    }
  }

  async subirPDFDrive(archivo) {
    let frmArchivo = new FormData();
    let rutaCarga = 'EstudioSocioEconomico/' + this.vecEstudiante[0]['periodo'] + '/' + this.vecEstudiante[0]['carrera'] + '_' + this.vecEstudiante[0]['periodo'] + '_' + this.vecEstudiante[0]['cedula'].replace('-', '') + '_EstSocioEconomico.pdf';
    frmArchivo.append('idAplicacion', this.recBecas.idAplicacion);
    frmArchivo.append('idCredencial', "1");
    frmArchivo.append('activo', "true");
    frmArchivo.append('ruta', rutaCarga);
    frmArchivo.append('file', archivo);
    await this.srvInsert.subirArchivos(frmArchivo, this.tokenDrive).subscribe(resSubir => {
      if (resSubir.success) {
        //INGRESAMOS EL DOCUMENTO PARA LA REVISION POR PARTE DEL/A DIRECTOR/A
        this.srvInsert.ingresoSocioEconomico(this.vecEstudiante[0].tipoProm, rutaCarga, 1, localStorage.getItem('ciUsuario'), 3, this.vecEstudiante[0]['beca'], this.vecEstudiante[0]['periodo'],
          this.vecEstudiante[0]['cedula'], 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 3).subscribe(res => {
            if (res.encuesta) {
              this.alerti.success('Archivo enviado con éxito');
              this.opEditable = true; this.opVerObserva = true;
              window.location.reload();
            }
          });
      }
    });
    this.cargando.cerrar();
  }
  //OBTENER LA DATA DE FIRMAS
  async verPieFirmas(analista) {
    //RECUPERAMOS LA INFORMACION DEL ANALISTA A CARGO
    const resAna = await new Promise<any>(resolve =>
      this.srvSelect.gestionUsuarios(2, analista, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resAna.success) {
      this.vecEstudiante[0]['analista'] = resAna.usuario[0]['strNombres'] + ' ' + resAna.usuario[0]['strApellidos'];
      this.vecEstudiante[0]['cargoAna'] = resAna.usuario[0]['strCargo'];
    }
    //RECUPERAMOS LA INFORMACION DEL DIRECTOR DE TURNO
    const resDir = await new Promise<any>(resolve =>
      this.srvSelect.gestionOtros(7, '5').subscribe(translated => {
        resolve(translated)
      }));
    if (resDir.success) {
      this.vecEstudiante[0]['director'] = resDir.ajustes[0]['strValor'];
      this.vecEstudiante[0]['cargoDir'] = resDir.ajustes[0]['strDescripcion'];
    }
  }
  //VER EL DETALLE DE LA INFORMACION DE LAS MATERIAS TOMADAS POR EL ESTUDIANTE EN UN PERÍODO
  verNotasMaterias() {
    if (this.vecEstudiante[0]['cedula'] != '') {
      console.log(this.vecEstudiante[0]['cedula'] + '     =====     ' + this.vecEstudiante[0]['periodo'])
    }
    else
      this.alerti.error('Debe ingresar un estudiante para el análisis');
  }
  verDataObservacion(nombModal) {
    this.mr = this.modalService.open(nombModal);
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }

}
